import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import SSRIcon from '@ingka/ssr-icon';
import blockOutPath from '@ingka/ssr-icon/paths/block-out';
import Text from '@ingka/text';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import '@ingka/inline-message/dist/style.css';
import { signOut } from '@/api/client';
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';
import styles from './AccessDeniedPage.module.css';

export default function AccessDeniedPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const errorFromUrl = searchParams.get('error');
  const stashedError = sessionStorage.getItem('authError');
  const displayError =
    errorFromUrl || stashedError || 'An unexpected error occurred during sign-in.';

  // Stash on mount for StrictMode double-mount safety and to survive URL cleanup
  useEffect(() => {
    if (errorFromUrl) {
      sessionStorage.setItem('authError', errorFromUrl);
    }
  }, [errorFromUrl]);

  const handleSignOutAndTryAgain = async () => {
    sessionStorage.removeItem('authError');
    try {
      await signOut();
    } catch {
      navigate('/');
    }
  };

  const handleGoHome = () => {
    sessionStorage.removeItem('authError');
    navigate('/');
  };

  return (
    <div className={styles.shell}>
      <AppHeader showArchive={false} showAuth={false} showLocations={false} />
      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.iconWrap}>
            <SSRIcon paths={blockOutPath} />
          </div>

          <Text tagName="h1" textStyle="Heading.L" className={styles.title}>
            Access denied
          </Text>

          <Text tagName="p" textStyle="Body.L" className={styles.subtitle}>
            You couldn't be signed in to CMPMaster.
          </Text>

          <div className={styles.message}>
            <InlineMessage variant="negative" title="Reason" body={displayError} />
          </div>

          <Text tagName="p" textStyle="Body.M" className={styles.help}>
            If you believe you should have access, please contact the CMPMaster team with the reason
            above. Once access has been granted, sign in again.
          </Text>

          <div className={styles.actions}>
            <Button
              type="emphasised"
              text="Sign out and try again"
              onClick={handleSignOutAndTryAgain}
            />
            <Button type="secondary" text="Back to home" onClick={handleGoHome} />
          </div>
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
